import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { checkAllInputs } from 'src/utils/checkInputs';
import { apiGlobal } from 'src/api/global';

import { IConsultantData } from 'src/environments/CheckoutConsultantAPP/interfaces';
import InputCheckout from 'src/components/functional/InputCheckout';

import { ButtonContinue, ContainerForm, ErrorMsg, SideBySide, TitleForm } from './style';

type Props = {
  consultantData: IConsultantData;
  setConsultantData: Dispatch<SetStateAction<IConsultantData>>;
  setComponent: Dispatch<SetStateAction<number>>;
};

export default function PurchaseForms({
  consultantData,
  setConsultantData,
  setComponent,
}: Props): JSX.Element {
  const [msgError, setMsgError] = useState('Confira os dados e tente novamente!');
  const [visibility, setVisibility] = useState('hidden');
  const [disabled, setDisabled] = useState(false);
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    apiGlobal
      .getCep(consultantData.zipCode)
      .then((getCepData) => {
        if (!getCepData.erro) {
          setConsultantData({
            ...consultantData,
            neighborhood: getCepData.bairro,
            street: getCepData.logradouro,
            city: getCepData.localidade,
            state: getCepData.uf,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [refetch]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    setConsultantData({
      ...consultantData,
      [name]: value,
    });
  };

  const showErrorMessage = (): void => {
    setVisibility('block');
    setTimeout(() => {
      setVisibility('hidden');
    }, 5000);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();

    const message = checkAllInputs(
      consultantData.consultantName,
      consultantData.consultantCpf,
      consultantData.consultantPhone
    );

    if (message !== 'All inputs are valid!') {
      showErrorMessage();
      setMsgError(message);
      return;
    }

    setDisabled(false);
    setComponent((prev) => prev + 1);
  };

  return (
    <ContainerForm onSubmit={handleSubmit}>
      <TitleForm>
        <p>Dados da assinatura</p>
        <span>Verifique se os seus dados estão corretos e preencha o que estiver faltando!</span>
      </TitleForm>
      <InputCheckout
        name="consultantName"
        label="Nome"
        type="text"
        value={consultantData.consultantName}
        onChange={handleChange}
        placeholder="Ex. Joana Mariano"
        maxLength={40}
        colorBorder={consultantData.consultantName !== '' ? '#000000' : '#c7c7c7'}
      />
      <InputCheckout
        name="consultantEmail"
        label="Email"
        type="email"
        value={consultantData.consultantEmail}
        onChange={handleChange}
        placeholder="Ex. joanamariano@gmail.com"
        maxLength={40}
        colorBorder={consultantData.consultantEmail !== '' ? '#000000' : '#c7c7c7'}
      />
      <InputCheckout
        name="consultantCpf"
        label="CPF"
        mask="999.999.999-99"
        value={consultantData.consultantCpf}
        onChange={handleChange}
        placeholder="Ex: 000.000.000-00"
        inputMode="numeric"
        colorBorder={consultantData.consultantCpf !== '' ? '#000000' : '#c7c7c7'}
      />
      <InputCheckout
        name="zipCode"
        label="CEP"
        value={consultantData.zipCode}
        onChange={handleChange}
        onBlur={() => {
          setRefetch(!refetch);
        }}
        mask="99999-999"
        inputMode="numeric"
        placeholder="Ex: 00000-000"
        colorBorder={
          consultantData.zipCode && consultantData.zipCode !== '' ? '#000000' : '#c7c7c7'
        }
      />
      <SideBySide>
        <InputCheckout
          name="city"
          label="Cidade"
          type="text"
          inputWidth="63vw"
          value={consultantData.city}
          onChange={handleChange}
          placeholder="São Paulo"
          maxLength={30}
          colorBorder={consultantData.city && consultantData.city !== '' ? '#000000' : '#c7c7c7'}
        />
        <InputCheckout
          name="state"
          label="Estado"
          type="text"
          inputWidth="23.666vw"
          value={consultantData.state}
          onChange={handleChange}
          maxLength={2}
          placeholder="SP"
          colorBorder={consultantData.state && consultantData.state !== '' ? '#000000' : '#c7c7c7'}
        />
      </SideBySide>
      <InputCheckout
        name="neighborhood"
        label="Bairro"
        type="text"
        value={consultantData.neighborhood}
        onChange={handleChange}
        maxLength={50}
        placeholder="Ex: Morumbi"
        colorBorder={consultantData.neighborhood !== '' ? '#000000' : '#c7c7c7'}
      />
      <SideBySide>
        <InputCheckout
          name="street"
          label="Rua"
          type="text"
          inputWidth="63vw"
          value={consultantData.street}
          onChange={handleChange}
          maxLength={50}
          placeholder="Ex. Juscelino kubitschek"
          colorBorder={consultantData.street !== '' ? '#000000' : '#c7c7c7'}
        />
        <InputCheckout
          name="streetNumber"
          label="Número"
          inputWidth="23.666vw"
          value={consultantData.streetNumber}
          onChange={handleChange}
          placeholder="Ex. 123"
          maxLength={6}
          inputMode="numeric"
          colorBorder={consultantData.streetNumber !== '' ? '#000000' : '#c7c7c7'}
        />
      </SideBySide>
      <InputCheckout
        name="consultantPhone"
        label="Whatsapp"
        value={consultantData.consultantPhone}
        onChange={handleChange}
        mask="(99) 99999-9999"
        placeholder="Ex. (11) 90000-0000"
        inputMode="numeric"
        colorBorder={consultantData.consultantPhone !== '' ? '#000000' : '#c7c7c7'}
      />
      <ErrorMsg visibility={visibility}>{msgError}</ErrorMsg>
      <ButtonContinue type="submit" disabled={disabled}>
        CONTINUAR
      </ButtonContinue>
    </ContainerForm>
  );
}
